<template>
  <a-form
    ref="formRef"
    :model="formState"
    :label-col="labelCol"
    :wrapper-col="wrapperCol"
  >
    <a-row :gutter="16">
      <a-col :span="8">
        <a-form-item label="ID" name="id">
          <a-input v-model:value="formState.id" placeholder="请输入" />
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="活动名称" name="activityName">
          <a-input
            v-model:value="formState.activityName"
            placeholder="请输入"
          />
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="状态" name="status">
          <a-select
            v-model:value="formState.status"
            placeholder="请选择"
            :options="options"
          >
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="活动类型" name="activityType">
          <a-select v-model:value="formState.activityType" placeholder="请选择">
            <a-select-option :value="1">转盘</a-select-option>
            <a-select-option :value="2">刮刮乐</a-select-option>
            <a-select-option :value="3">盲盒</a-select-option>
            <a-select-option :value="4">卡牌</a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="8">
        <a-form-item label="活动时间" name="time">
          <a-range-picker
            v-model:value="formState.time"
            :format="formatDate"
            :placeholder="['开始时间', '结束时间']"
            :show-time="{
              defaultValue: [
                moment('00:00:00', 'HH:mm:ss'),
                moment('23:59:59', 'HH:mm:ss')
              ]
            }"
            @change="onChangeRangTime"
          />
        </a-form-item>
      </a-col>
      <a-col :span="8" style="text-align: right;">
        <a-space>
          <a-button type="default" @click="handleReset">重置</a-button>
          <a-button type="primary" @click="handleQuery">查询</a-button>
        </a-space>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import { inject, reactive, toRefs } from 'vue'
import moment from 'moment'

export default {
  setup() {
    const state = reactive({
      statusOptions: [
        { label: '全部', value: '' },
        { label: '转盘', value: 1 }
      ],
      options: [
        { label: '全部', value: '' },
        { label: '未开始', value: 1 },
        { label: '进行中', value: 2 },
        { label: '已结束', value: 3 }
      ],
      formatDate: 'YYYY-MM-DD HH:mm:ss',
      labelCol: { span: 4 },
      wrapperCol: { span: 20 }
    })

    return {
      ...toRefs(state),
      ...toRefs(inject('initData')),
      moment
    }
  }
}
</script>
